import { type SsoProvider } from '@store/api/ssoEndpoints';

/**
 * What the settings page shows differently for each provider, in one place, as the backend's
 * `ssoPresets` keeps what it does differently.
 */
export interface SsoProviderPreset {
  /** The provider's name in the menu and on the card. */
  label: string;
  /** The setting that names the provider: the tenant, or the issuer's address. */
  names: 'tenantId' | 'issuer';
  /** A guide to registering this server with the provider, shown under the connection. */
  guide?: string;
  /** Whether the token method, the scopes, the claims and the verified address are set here. */
  advanced: boolean;
  /** Said under an address a trial found unverified, where this provider needs telling to verify it. */
  unverifiedEmailNote?: string;
}

export const ssoProviderPresets: Record<SsoProvider, SsoProviderPreset> = {
  entra: {
    label: 'ServerConfig_Sso_Provider_Entra',
    names: 'tenantId',
    guide: 'ServerConfig_Sso_EntraGuide',
    advanced: false,
    // Entra says so only in `xms_edov`, an optional claim the app registration has to ask for.
    unverifiedEmailNote: 'ServerConfig_Sso_Trial_EmailUnverified_Entra',
  },
  oidc: {
    label: 'ServerConfig_Sso_Provider_Oidc',
    names: 'issuer',
    advanced: true,
  },
};
